import { businessRegistrationState } from './businessRegistration.state';
import { businessRegistrationActions } from './businessRegistration.actions';
import { businessRegistrationGetters } from './businessRegistration.getters';
import { businessRegistrationMutations } from './businessRegistration.mutations';

export default {
  state: businessRegistrationState,
  actions: businessRegistrationActions,
  getters: businessRegistrationGetters,
  mutations: businessRegistrationMutations,
};
